import { MagnifyingGlassMinus } from "@phosphor-icons/react";

interface EmptyStateProps {
  onClear: () => void;
}

export function EmptyState({ onClear }: EmptyStateProps) {
  return (
    <div
      role="status"
      className="flex flex-col items-center justify-center gap-5 rounded-2xl px-6 py-16 text-center"
      style={{
        background: "var(--opella-surface)",
        border: "1px dashed var(--opella-sidebar-border)",
      }}
    >
      <div
        className="flex size-14 items-center justify-center rounded-full"
        style={{
          background: "var(--opella-accent-soft)",
          color: "var(--opella-accent)",
        }}
      >
        <MagnifyingGlassMinus size={26} weight="bold" aria-hidden />
      </div>
      <div className="flex flex-col gap-2">
        <h3
          className="text-lg font-semibold"
          style={{ color: "var(--opella-fg)" }}
        >
          No videos match your filters
        </h3>
        <p
          className="max-w-sm text-sm"
          style={{ color: "var(--opella-muted)" }}
        >
          Try broadening the markets, clearing your search, or browsing the full
          library.
        </p>
      </div>
      <button type="button" onClick={onClear} className="opella-btn-primary">
        Clear all filters
      </button>
    </div>
  );
}
